import { NgModule, Injectable, inject } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';
import { SessionService } from '@monsido/core/session/session.service';
import { HasAccessPipe } from '@client/app/filters/has-access.pipe';

import { AdminPagePerformanceProfilesComponent } from './profiles/profiles.component';

@Injectable({ providedIn: 'root' })
export class PagePerformanceAdminAccessGuard {
    private activeFeatureService = inject(ActiveFeatureService);
    private stateService = inject(StateService);
    private monUIRouterTransitionService = inject(MonUIRouterTransitionService);
    private sessionService = inject(SessionService);
    private hasAccessPipe = inject(HasAccessPipe);

    checkAccess (transition: Transition) {
        const MON_MODULES = { performance: 'performance' };

        if (
            this.activeFeatureService.isFeatureActive('admin_page_performance') &&
            this.hasAccessPipe.transform(this.sessionService.me, MON_MODULES.performance)
        ) {
            return true;
        }

        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.domain.dashboard', params) as unknown as Promise<void>;
        });
    }
}

/**
 * Page Performance Admin routing configuration for Angular.
 * This module provides routing for the Page Performance Admin section with proper access control.
 */

const pagePerformanceAdminStates = [
    // Access-controlled abstract route
    {
        name: 'base.customer.admin.page_performance',
        url: '/page-performance',
        abstract: true,
        data: {
            htmlContent: '<div ui-view></div>',
        },
        resolve: [
            {
                token: 'pagePerformanceAdminAccess',
                deps: [PagePerformanceAdminAccessGuard, Transition],
                resolveFn: (guard: PagePerformanceAdminAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
    },

    // Child routes with components
    {
        name: 'base.customer.admin.page_performance.dashboard',
        url: '/profiles',
        views: {
            'content@base.customer.admin': {
                component: AdminPagePerformanceProfilesComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - Admin Page Performance Profiles',
        },
    },
];

@NgModule({
    imports: [UIRouterModule.forChild({ states: pagePerformanceAdminStates })],
    exports: [UIRouterModule],
})
export class PagePerformanceAdminRoutingModule { }
